import { render, staticRenderFns } from "./departmentDialog.vue?vue&type=template&id=b2140cfa&scoped=true&"
import script from "./departmentDialog.vue?vue&type=script&lang=js&"
export * from "./departmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./departmentDialog.vue?vue&type=style&index=0&id=b2140cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2140cfa",
  null
  
)

export default component.exports